let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g5Cqr")).then(() => parcelRequire('bOZZh'));